import { BaseError } from '@dynamic-labs-sdk/client';

type SessionClosedUnexpectedlyErrorParams = {
  /**
   * The topic of the session that closed unexpectedly.
   */
  sessionTopic: string;

  /**
   * The display name of the wallet that was associated with the session that closed unexpectedly.
   */
  walletDisplayName: string | null | undefined;
};

export class SessionClosedUnexpectedlyError extends BaseError {
  constructor({
    sessionTopic,
    walletDisplayName,
  }: SessionClosedUnexpectedlyErrorParams) {
    super({
      cause: null,
      code: 'session_closed_unexpectedly_error',
      docsUrl: null,
      name: 'SessionClosedUnexpectedlyError',
      shortMessage: walletDisplayName
        ? `WalletConnect session ${sessionTopic} closed unexpectedly. Associated wallet was ${walletDisplayName}`
        : `WalletConnect session ${sessionTopic} closed unexpectedly`,
    });
  }
}
